export default __webpack_public_path__ + "static/media/sessions_tg_bot.c58f80d4.jpg";